<div class="form-group">
  <label *ngIf="label" for="{{ inputId }}" class="form-label">
    <span *ngIf="isRequired" class="required">*</span>
    <span> {{ label }}</span>
  </label>
  <i class="selected-icon primary" [class]="postIcon"></i>
  <nb-form-field>
    <nb-icon pack="target" nbPrefix [icon]="svgIcon" *ngIf="svgIcon"></nb-icon>
    <nb-select fullWidth [placeholder]="placeholder" [optionsOverlayOffset]="overlayOffset" id="{{ inputId }}"
      [size]="size" [formControl]="control" [ngClass]="{ 'is-invalid': showErrors && control.errors }"
      (selectedChange)="selectedChange($event)" [disabled]="disabled">
      <nb-option *ngFor="let option of options" value="{{ option.value }}">
        <nb-icon [icon]="option.svgIcon" pack="target" *ngIf="option.svgIcon"></nb-icon>
        {{ option.label }}
        <i class="mx-2 options-icon primary" [class]="option.postIcon" *ngIf="option.postIcon"></i>
      </nb-option>
    </nb-select>
    <pes-form-error *ngIf="showErrors && control.errors" [control]="control" [errors]="errors"></pes-form-error>
  </nb-form-field>
</div>